export function mypage() {
  if(!document.getElementById("mypage")) return;

  const answerOffer = function(offerId, answer, callback) {
    const url = '/minside';
    const xhr = new XMLHttpRequest();
    xhr.open('POST', url);

    const formData = new FormData();
    formData.append("offer_id", offerId);
    formData.append("answer", answer);

    xhr.onload = function () {
      if (xhr.status === 200) {
        window.location.href = window.location.href;
      }
    }
    xhr.send(formData);
  }

  const offers = document.getElementsByClassName("offer");
  for(let i=0; i<offers.length; i++) {
    const offer = offers[i];
    const offerId = offer.dataset["id"];
    const yes = offer.getElementsByClassName("yes")[0];
    const no = offer.getElementsByClassName("how-about-no")[0];

    yes.addEventListener("click", function(e) {
      e.preventDefault();
      answerOffer(offerId, "accepted_user");
    });

    no.addEventListener("click", function(e) {
      e.preventDefault();
      answerOffer(offerId, "declined_user");
    });
  }
}

